module.exports = __webpack_public_path__ + "static/img/6.815afec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/6.png
// module id = Kv4N
// module chunks = 0